import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { SharedService } from 'src/app/services/shared/shared.service';

@Component({
  selector: 'app-body-type-warn',
  templateUrl: './body-type-warn.component.html',
  styleUrls: ['./body-type-warn.component.scss'],
})
export class BodyTypeWarnComponent implements OnInit {
  public saved: Subject<boolean>;
  public content: string = null;

  constructor(
    public modal: BsModalRef,
    public sharedService: SharedService,
    public router: Router
  ) {}

  ngOnInit(): void {}

  confirm() {
    let data: object = null;
    this.sharedService.vinInformation.subscribe((res: object) => {
      data = res;
    });

    if (!(data && Object.keys(data).length && data['body_type_id']['id'])) {
      this.modal.hide();
      return;
    }

    this.saved.next(true);
    this.saved.complete();
    // this.router.navigate(['/vam/information']);
  }
}
